@if (!authService.isLoggedIn()) {
  <traction-login />
} @else {
  <div class="flex flex-col h-screen font-sans">
    <kh-header />
    <div class="flex flex-1 overflow-hidden">
      <side-nav class="bg-[#424553] flex-shrink-0" />
      <main class="flex-1 min-w-0 rounded-lg bg-[#151829] my-2 mx-1">
        <router-outlet></router-outlet>
        <app-alert></app-alert>
      </main>
    </div>
    <kh-footer />
  </div>
}
